<template>
  <v-row>
    <!-- @slot Display a message on the left of the enum selector. -->
    <v-col class="text-right px-0 my-auto"
           cols="4"
           style="font-size: 14px; line-height: 15px;">
      <slot name="prepend"/>
    </v-col>

    <v-col ref="col" :class="'text-center px-0 my-auto enumcol-' + colNumber" cols="4">
      <v-menu v-for="index in size"
              :key="index-1"
              :disabled="tooltips.length !== size"
              color="white"
              offset-y
              open-on-hover
              auto
              :attach="$refs.col"
              content-class="tooltip-menu"
      >
        <template #activator="{ on }">
          <v-btn v-on="on"
                 :class="individual ? 'mx-xs-0 mx-sm-1 mx-md-6' : 'mx-3'"
                 :color="color"
                 :disabled="disabled"
                 icon
                 text
                 style="z-index: 10;"
                 @click.native="()=>click(index)"
          >
            <v-icon ref="icon"
                    :color="index - 1 === workingData ? 'rgba(97, 195, 120, 1)' : 'rgb(211,211,211)'"
                    :size="index - 1 === workingData ? 12 : 6">
              {{ index - 1 === workingData ? selectedIcon : unselectedIcon }}
            </v-icon>
          </v-btn>
        </template>
        <div v-if="tooltips.length === size">
          <div class="tooltip-title">{{ tooltips[index - 1].title }}</div>
          <div class="tooltip-text">{{ tooltips[index - 1].text }}</div>
        </div>
      </v-menu>
    </v-col>

    <!-- @slot Display a message on the right of the enum selector. -->
    <v-col class="text-left px-0  my-auto"
           cols="4"
           style="font-size: 14px; line-height: 15px;">
      <slot name="append"/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'finEnumSelector',
  props: {
    /** the value / index of the selected element (starting at 0) */
    value: {
      type: Number,
      default: null
    },
    /** the col number */
    colNumber: {
      type: Number
    },
    /** the number of elements to draw into one line */
    size: {
      type: Number,
      default: 3
    },
    /** the color of the icons (selected + unselected) */
    color: {
      type: String,
      default() {
        return this.$finColors.primaryDark
      }
    },
    /** the icon displaying the selected state */
    selectedIcon: {
      type: String,
      default: 'mdi-checkbox-blank-circle-outline'
    },
    /** the icon displaying the unselected state */
    unselectedIcon: {
      type: String,
      default: 'mdi-checkbox-blank-circle'
    },
    /** disables the component */
    disabled: {
      type: Boolean,
      default: false
    },
    /** Puts input in readonly state */
    readonly: {
      type: Boolean,
      default: false
    },
    /** the tooltips for each of the selection icons - must match the `size` */
    tooltips: {
      type: Array,
      default() {
        return []
      }
    },
    individual: {}
  },
  data() {
    return {
      workingData: this.value,
    }
  },
  methods: {
    click(index) {
      if (this.readonly) {
        return
      }
      this.workingData = index - 1
    },
    getSelectedXPosition() {
      if (!this.$refs.icon || this.workingData == null || this.workingData < 0) {
        return 0
      }
      return this.$refs.icon[this.workingData].$el.getBoundingClientRect().left - this.$el.getBoundingClientRect().left
    },
    getSelectedTopPosition() {
      if (!this.$refs.icon || this.workingData == null || this.workingData < 0) {
        return 0
      }
      return this.$refs.icon[this.workingData].$el.getBoundingClientRect().top // - this.$el.getBoundingClientRect().top
    },
    getSelectedBottomPosition() {
      if (!this.$refs.icon || this.workingData == null || this.workingData < 0) {
        return 0
      }
      return this.$refs.icon[this.workingData].$el.getBoundingClientRect().bottom // - this.$el.getBoundingClientRect().bottom
    }
  },
  computed: {
    col() {
      return '.enumcol' + this.colNumber
    }
  },
  watch: {
    value() {
      this.workingData = this.value
    },
    workingData() {
      /**
       * Input change event.
       *
       * @event input
       * @type {object}
       */
      this.$emit('input', this.workingData)
    }
  },
}
</script>

<style lang="scss" scoped>
.tooltip-menu {
  background-color: $fin-color-primary-light;
  color: $fin-color-primary-dark;
  border: 1px solid lightgray !important;
  max-width: 280px;
  width: 100%;
  text-align: center;
  box-shadow: 2px 2px 2px lightgray;
  padding: 5px;
}

.tooltip-menu div {
  max-width: 100% !important;
}

.tooltip-title {
  font-weight: bold;
  line-height: 20px;
}

.tooltip-text {
  font-weight: normal;
  line-height: 20px;
}

.v-btn {
  margin: 0 0 !important; /* reduce default margin to fit into dialog */
}

.v-btn:active {
  background: radial-gradient(circle, rgba(255, 255, 255, 255) 20%, rgba(255, 255, 255, 255) 40%, rgba(97, 195, 120, 1) 45%, rgba(255, 255, 255, 255) 50%, rgba(255, 255, 255, 255) 60%, rgba(97, 195, 120, 1) 65%, rgba(255, 255, 255, 255) 70%);
}
</style>
